module.exports = __webpack_public_path__ + "img/end-counting-icon.527328ad.svg";